import { FC } from "react";
import qs from "query-string";
import { Redirect, useLocation } from "react-router-dom";
import { buildFilteredChainsUrl } from "./PlacesFoodsTabs/PlacesFoodsTabs.helpers";
import { getRedirectTargetTab } from "./Places.helpers";

/**
 * `/places` is retired as a destination — US Chains (`/chains`) replaced it —
 * but it stays a LIVE route so old links keep working instead of silently
 * dropping the user on Home. Still in the wild:
 *
 * - bookmarks and already-sent emails carrying absolute `/places?...` URLs
 * - platform-ui-lib global search, until the parameter store's `snapChainsUrl`
 *   (`/places?q=`) and `snapChainsInMenuUrl` (`/places?tabIndex=2&q=`) are
 *   repointed at `/chains`
 *
 * Its only job is translating the legacy query into the US Chains equivalent:
 * `?q=` becomes `?includes=`, and `?tabIndex=2` becomes `?tab=foods`. Matches
 * what the old page did, so no link changes meaning.
 */
const Places: FC = () => {
    const location = useLocation();
    const parsedSearch = qs.parse(location.search);
    const rawQuery = parsedSearch.q;
    const searchQuery = (Array.isArray(rawQuery) ? rawQuery[0] : rawQuery) ?? '';
    const rawTabIndex = Array.isArray(parsedSearch.tabIndex)
        ? parsedSearch.tabIndex[0]
        : parsedSearch.tabIndex;

    return <Redirect to={buildFilteredChainsUrl(searchQuery, getRedirectTargetTab(Number(rawTabIndex)))}/>;
};

export default Places;
